import { render, staticRenderFns } from "./recommendedLineForm.vue?vue&type=template&id=8b64f0c6&scoped=true"
import script from "./recommendedLineForm.vue?vue&type=script&lang=js"
export * from "./recommendedLineForm.vue?vue&type=script&lang=js"
import style0 from "./recommendedLineForm.vue?vue&type=style&index=0&id=8b64f0c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b64f0c6",
  null
  
)

export default component.exports